import eventMessagesService from '@/services/events/eventMessagesService';
import {consumeExternalLinkOpened} from '@/services/events/externalLinkReturnTracker';

import useOnReturnToTab from './useOnReturnToTab';

/**
 * When the user returns to the tab/iframe after having opened an external link
 * from a badge action, ask the parent app to refetch loyalty data.
 *
 * Mirrors the legacy iqosconnect-pwa-npi `useLoyaltyFetchManager`, but here we
 * only request a refetch when an external link was actually opened (since this
 * iframe doesn't own the loyalty network call). The parent will respond with
 * `UWM_REFRESH_BADGES_DATA` once fresh `badgesConfiguration` is available.
 */
const useExternalLinkReturnRefetch = () => {
    useOnReturnToTab(() => {
        if (!consumeExternalLinkOpened()) return;
        eventMessagesService.sendRefetchDataRequest();
    });
};

export default useExternalLinkReturnRefetch;
